export default "__VITE_ASSET__BYAqftBL__"